export default __webpack_public_path__ + "static/media/us-states.4353293a.geojson";